export default "__VITE_ASSET__qGojcgpI__"